import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext, useEffect, useState } from 'react';
import axiosInstance, { isTokenExpired, refreshAccessToken } from "../axiosHelper/interceptor";
import { jwtDecode } from "jwt-decode";
export const ACCESS_TOKEN_LOCAL_STORAGE_KEY = 'accessToken';
export const REFRESH_TOKEN_LOCAL_STORAGE_KEY = 'refreshToken';
const AuthContext = createContext(undefined);
export const AuthProvider = ({ children }) => {
    const [userData, setUserData] = useState(null);
    const isAuthenticated = userData !== null;
    const [loading, setLoading] = useState(true);
    const login = async (username, password) => {
        setLoading(true);
        try {
            const response = await axiosInstance.post('/api/auth/token/', { username, password });
            if (response.status === 200) {
                const data = response.data;
                savePersistedTokens(data);
                setUserDataFromTokens(data);
                return data;
            }
            else {
                setUserDataHandler(null);
                throw new Error('Authentication failed!');
            }
        }
        catch (error) {
            console.error('Error logging in:', error);
            throw error;
        }
        finally {
            setLoading(false);
        }
    };
    const logout = () => {
        setUserDataHandler(null);
    };
    const clearTokenStorage = () => {
        localStorage.removeItem(ACCESS_TOKEN_LOCAL_STORAGE_KEY);
        localStorage.removeItem(REFRESH_TOKEN_LOCAL_STORAGE_KEY);
    };
    const savePersistedTokens = (tokens) => {
        console.log("Saving tokens to local storage: ", tokens);
        if (tokens.access && tokens.refresh) {
            localStorage.setItem(ACCESS_TOKEN_LOCAL_STORAGE_KEY, tokens.access);
            localStorage.setItem(REFRESH_TOKEN_LOCAL_STORAGE_KEY, tokens.refresh);
        }
    };
    const setUserDataFromTokens = (tokens) => {
        if (tokens) {
            setUserDataFromToken(tokens.access);
        }
        else {
            setUserData(null);
        }
    };
    const setUserDataFromToken = (token) => {
        const decoded = jwtDecode(token);
        const data = {
            username: decoded.username,
            isStaff: decoded.isStaff,
        };
        setUserDataHandler(data);
    };
    const checkAuth = async () => {
        let accessToken = localStorage.getItem(ACCESS_TOKEN_LOCAL_STORAGE_KEY);
        let refreshToken = localStorage.getItem(REFRESH_TOKEN_LOCAL_STORAGE_KEY);
        if (!accessToken || !refreshToken) {
            setUserDataHandler(null);
            setLoading(false);
            return;
        }
        if (isTokenExpired(refreshToken)) {
            console.log("Refresh token expired. Logging out.");
            logout();
            setLoading(false);
            return;
        }
        else if (isTokenExpired(accessToken)) {
            console.log("(AuthContext) Triggering refreshAccessToken");
            const newTokens = await refreshAccessToken();
            savePersistedTokens(newTokens);
            accessToken = newTokens.access;
        }
        setUserDataFromToken(accessToken);
        setLoading(false);
    };
    const setUserDataHandler = (data) => {
        if (data === null) {
            clearTokenStorage();
            setUserData(null);
        }
        else {
            setUserData(data);
        }
    };
    useEffect(() => {
        console.log("Checking Authentication status in AuthContext useEffect");
        checkAuth();
        console.log("User data: ", userData);
        console.log("Is authenticated: ", isAuthenticated);
        console.log("Loading: ", loading);
    }, []);
    return (_jsx(AuthContext.Provider, { value: { isAuthenticated, loading, checkAuth, login, logout, userData }, children: children }));
};
export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};
